import React from "react";
import { Link } from 'react-router-dom'
import heroImage from '../../images/slider/slide-1-compressed.jpeg';



const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const Hero2 = (props) => {
    return (

        <section className="wpo-hero-slider-s2" >
            <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${heroImage})` }}>
                <div className="container-fluid">
                    <div className="slide-content">
                        <div  className="slide-sub-title">
                            <h2>Point Cook<br/><span>Islamic Community</span></h2>
                        </div>
                        <div  className="slide-btns">
                            <Link onClick={ClickHandler} to="/about" className="theme-btn-primary">About Us</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero2;